import { Plus, Trash2 } from "lucide-react";
import { INVOICE_CURRENCIES, amt, emptyCustomer, invoiceTotals } from "../lib/invoice";

export default function InvoiceForm({ form, setForm, customers = [], prefix }) {
  const set = (key, value) => setForm(current => ({ ...current, [key]: value }));
  const setCustomer = (key, value) => setForm(current => ({ ...current, customer: { ...current.customer, [key]: value } }));
  const setItem = (index, key, value) => setForm(current => ({
    ...current,
    items: current.items.map((item, i) => (i === index ? { ...item, [key]: value } : item)),
  }));
  const addItem = () => setForm(current => ({ ...current, items: [...current.items, { qty: "1", description: "", price: "" }] }));
  const removeItem = index => setForm(current => ({
    ...current,
    items: current.items.length > 1 ? current.items.filter((_, i) => i !== index) : current.items,
  }));

  const pickCustomer = name => {
    const found = customers.find(c => c.name === name);
    setForm(current => ({ ...current, customer: found ? { ...emptyCustomer(), ...found } : { ...emptyCustomer(), name: "" } }));
  };

  const totals = invoiceTotals(form);
  const sameCurrency = form.item_currency === form.total_currency;

  return (
    <>
      <div className="form-row">
        <div className="field">
          <label>Fatura no</label>
          <input data-testid={`${prefix}-number-input`} placeholder="Otomatik" value={form.number}
            onChange={e => set("number", e.target.value)}/>
          <small className="hint">Boş bırakırsan sıradaki numara otomatik verilir.</small>
        </div>
        <div className="field">
          <label>Fatura tarihi</label>
          <input data-testid={`${prefix}-date-input`} required type="date" value={form.invoice_date}
            onChange={e => set("invoice_date", e.target.value)}/>
        </div>
      </div>

      <div className="field">
        <label>Kayıtlı müşteri</label>
        <select data-testid={`${prefix}-customer-select`} value={customers.some(c => c.name === form.customer.name) ? form.customer.name : ""}
          onChange={e => pickCustomer(e.target.value)}>
          <option value="">Yeni müşteri gir</option>
          {customers.map(c => <option key={c.id} value={c.name}>{c.name}</option>)}
        </select>
      </div>

      <div className="field">
        <label>Müşteri ünvanı</label>
        <input data-testid={`${prefix}-customer-name`} required placeholder="Ör: BTB TOURISM LLC"
          value={form.customer.name} onChange={e => setCustomer("name", e.target.value)}/>
      </div>
      <div className="field">
        <label>Adres</label>
        <input data-testid={`${prefix}-customer-address`} placeholder="Damac Executive Heights, Tecom Office:905 Dubai / UAE"
          value={form.customer.address} onChange={e => setCustomer("address", e.target.value)}/>
      </div>
      <div className="form-row">
        <div className="field">
          <label>Telefon</label>
          <input data-testid={`${prefix}-customer-phone`} value={form.customer.phone} onChange={e => setCustomer("phone", e.target.value)}/>
        </div>
        <div className="field">
          <label>TRN</label>
          <input data-testid={`${prefix}-customer-trn`} value={form.customer.trn} onChange={e => setCustomer("trn", e.target.value)}/>
        </div>
      </div>
      <div className="form-row">
        <div className="field">
          <label>Web</label>
          <input data-testid={`${prefix}-customer-web`} value={form.customer.web} onChange={e => setCustomer("web", e.target.value)}/>
        </div>
        <div className="field">
          <label>E-posta</label>
          <input data-testid={`${prefix}-customer-email`} value={form.customer.email} onChange={e => setCustomer("email", e.target.value)}/>
        </div>
      </div>
      <label className="check-line">
        <input type="checkbox" data-testid={`${prefix}-save-customer`} checked={!!form.save_customer}
          onChange={e => set("save_customer", e.target.checked)}/>
        <span>Bu müşteriyi kayıtlı müşteri listesine ekle / güncelle</span>
      </label>

      <div className="invoice-items" data-testid={`${prefix}-items`}>
        <div className="items-head">
          <b>Fatura kalemleri</b>
          <button type="button" className="outline-btn small" data-testid={`${prefix}-add-item`} onClick={addItem}>
            <Plus size={14}/> Kalem ekle
          </button>
        </div>
        {form.items.map((item, index) => (
          <div className="item-row" key={index} data-testid={`${prefix}-item-${index}`}>
            <input className="qty" type="number" min="0.01" step="0.01" placeholder="Adet"
              data-testid={`${prefix}-item-qty-${index}`} value={item.qty} onChange={e => setItem(index, "qty", e.target.value)}/>
            <input className="desc" placeholder="Ör: June Sales Commission fee"
              data-testid={`${prefix}-item-desc-${index}`} value={item.description} onChange={e => setItem(index, "description", e.target.value)}/>
            <input className="price" type="number" min="0.01" step="0.01" placeholder={`Tutar (${form.item_currency})`}
              data-testid={`${prefix}-item-price-${index}`} value={item.price} onChange={e => setItem(index, "price", e.target.value)}/>
            <button type="button" className="icon-btn danger" title="Kalemi sil"
              data-testid={`${prefix}-item-remove-${index}`} onClick={() => removeItem(index)}><Trash2 size={14}/></button>
          </div>
        ))}
      </div>

      <div className="form-row">
        <div className="field">
          <label>Kalem para birimi</label>
          <select data-testid={`${prefix}-item-currency`} value={form.item_currency} onChange={e => set("item_currency", e.target.value)}>
            {INVOICE_CURRENCIES.map(c => <option key={c} value={c}>{c}</option>)}
          </select>
        </div>
        <div className="field">
          <label>Fatura (toplam) para birimi</label>
          <select data-testid={`${prefix}-total-currency`} value={form.total_currency} onChange={e => set("total_currency", e.target.value)}>
            {INVOICE_CURRENCIES.map(c => <option key={c} value={c}>{c}</option>)}
          </select>
        </div>
      </div>
      <div className="form-row">
        <div className="field">
          <label>Kur (1 {form.item_currency} = ? {form.total_currency})</label>
          <input data-testid={`${prefix}-rate-input`} type="number" min="0.0001" step="0.0001" disabled={sameCurrency}
            value={sameCurrency ? 1 : form.rate} onChange={e => set("rate", e.target.value)}/>
          <small className="hint">Dubai'de kur sabittir; elle değiştirene kadar aynı kalır.</small>
        </div>
        <div className="field">
          <label>VAT oranı (%)</label>
          <input data-testid={`${prefix}-vat-input`} type="number" min="0" max="100" step="0.1"
            value={form.vat_rate} onChange={e => set("vat_rate", e.target.value)}/>
        </div>
      </div>
      <label className="check-line">
        <input type="checkbox" data-testid={`${prefix}-vat-included`} checked={!!form.vat_included}
          onChange={e => set("vat_included", e.target.checked)}/>
        <span>Girilen tutar VAT dahildir (toplamdan geriye hesaplanır)</span>
      </label>

      <div className="field">
        <label>Fatura üzerine not <small className="hint">(isteğe bağlı)</small></label>
        <input data-testid={`${prefix}-notes-input`} value={form.notes} onChange={e => set("notes", e.target.value)}/>
      </div>

      <div className="invoice-preview" data-testid={`${prefix}-totals-preview`}>
        <span>Ara toplam <b data-testid={`${prefix}-preview-subtotal`}>{amt(totals.subtotal, form.total_currency)}</b></span>
        <span>VAT <b data-testid={`${prefix}-preview-vat`}>{amt(totals.vat, form.total_currency)}</b></span>
        <span className="grand">Genel toplam <b data-testid={`${prefix}-preview-grand`}>{amt(totals.grand, form.total_currency)}</b></span>
      </div>
    </>
  );
}
